<template>

  <div>
    <toolbar medium>
      <template v-slot:head>
        {{ $tc('asset-attributes.entity-name', 2) }}
      </template>

      <template v-slot:controls>
        <v-btn depressed small @click="edit()">
          <v-icon>add</v-icon> {{ $t('asset-attributes.new') }}
        </v-btn>
      </template>
    </toolbar>

    <ob-list :items="assetType.assetAttributes"
             :no-data-message="$t('asset-attributes.no-attributes')"
             v-slot="{ item }"
             @select="edit($event)"
             @remove="confirmDelete(() => remove($event))"
    >
      {{ item.name }}
    </ob-list>

  </div>

</template>

<script>
  import dialog from '../../helpers/dialog-client.es6'
  import Toolbar from '../../shared/toolbar'
  import AssetAttributeDialog from './asset-attributes/asset-attribute-dialog'
  import ObList from '../../shared/components/list'

  export default {
    name: 'asset-type-attributes',
    mixins: [ dialog ],

    props: [ 'assetType' ],

    methods: {
      async edit (attribute) {
        const result = await this.$dialog.showAndWait(AssetAttributeDialog, { attribute })

        if (result) {
          await this.$store.dispatch('updateItem', {
            modelName: 'asset-attributes',
            item: Object.assign(result, {assetTypeId: this.assetType.id})
          })

          this.$emit('change')
        }
      },

      async remove (attribute) {
        await this.$store.dispatch('destroyItem', { model: { name: 'asset-attributes' }, id: attribute.id })
        this.$emit('change')
      }
    },

    components: {
      ObList,
      Toolbar
    }
  }
</script>

<style scoped lang="scss">

</style>
